export const getBidTableRows = ({ mrqData, bidData, existedPos, project }) => {
  //console.log("ffrom getbidrows:", { mrqData, bidData, existedPos, project });
  const result = mrqData?.mrqMaterials?.map((m, i) => {
    let obj = {};
    let poData = {};

    const data = project?.data?.data || project?.data;
    console.log("est data", data);
    const pvEstData = [
      ...(data?.DGV_Shell_BOM || []),
      // ...(data?.DGV_Nozzle_Estimation || []),
      ...(data?.DGV_Nozzle_Material_Description || []),
    ];
    console.log("pvest: ", pvEstData);

    const estData = pvEstData
      ?.map((row, i) => {
        // console.log({ row });
        const time = row;
        const cost = row["Cost (US $)"] || row["Total Cost (US $)"];
        const description = row["Description"] || row["Material Description"];
        // const unit = row?.unit;

        return {
          time,
          cost,
          description,
          ...row,
          // unit,
          // ...row,
        };
      })
      .filter((row) => row.Components !== "Total");

    // console.log({ estData: estData });
    bidData.forEach((b) => {
      if (b.mrqMaterialId === m.id) {
        obj[b.vendor.name] = {
          vendorId: b.vendorId,
          time: b.time,
          cost: b.cost,
        };
        return obj[b.vendor.name];
      }
    });

    existedPos[0] &&
      existedPos[0].id &&
      existedPos.forEach((po) => {
        po.poMaterials.forEach((poMaterial) => {
          if (m.id === poMaterial.mrqMaterialId) {
            const record = bidData.filter(
              (m) =>
                m.vendor.name === poMaterial.vendor.name &&
                m.mrqMaterialId === poMaterial.mrqMaterialId
            )[0];
            const time = record?.time;
            const cost = record?.cost;

            poData = {
              selected: {
                name: poMaterial.vendor.name,
                time,
                cost,
              },
              po: po.poNumber,
              vendorId: poMaterial.vendor.id,
            };
          }
        });
      });

    // console.log({
    //   md: mrqData?.mrqMaterials?.map((m) => m.description),
    //   est: estData.map((r) => ({ d: r.description, c: r.cost })),
    //   isDone: m.description === estData[5]?.description,
    // });
    // console.log({ m });
    console.log({ desc: m, est: estData });

    const estCost =
      estData.find((r) => {
        console.log({ r, m });
        return (
          r.description === m.description &&
          r["Cost Code"] === m?.materials?.[0]?.costCode
        );
      })?.cost * m.quantity || "";

    const unit = (m) => {
      const isPlate = m?.description?.toLowerCase().includes("plate");
      const isPipe = m?.description?.toLowerCase().includes("pipe");
      const isHead = m?.materials?.[0]?.costCode
        ?.toLowerCase()
        .includes("head");

      if (m.unit) {
        return m.unit;
      } else if (isPipe && !isHead) {
        return "mm";
      } else {
        return "Nos";
      }
    };

    const row = {
      mrqMaterialId: m.id,
      materialCode: m.materialCode,
      tagNumber: m.materials[0].taggedMaterial?.tagNumber,
      costCode: m.materials?.[0]?.costCode,
      description: m.description,
      remarks: m.remarks,
      qty: m.quantity,
      unit: unit(m), //m?.materials?.[0]?.unit,

      ...obj,
      ...poData,
      est: m.estCost,
    };

    return row;
  });
  console.log({ result });
  return result && result[0] ? result : [];
};
